import { browserHistory } from 'react-router'

const initialState = {
	error: false,
	isLoading: false,
	isRequestingSearchData: false,
	isRequestingPlaceData: false,
	isOpen: false,
	// mixedResultsState: false,
	mapDetailsIsOpen: false,
	hasSearched: false,
	searchTerm: '',
	filters: false,
	filtersChanged: false,
	userLatLng: false,
	bounds: false,
	zoom: 11,
	mapCenter: {
		lat: -33.868820,
		lng: 151.209296
	},
	allowMapOverride: false,
	hoveredMarker: {
		display: false,
		title: '',
		type: ''
	},
	selectedMarker: false,
	searchResults: {
		has_results: false,
		results_number: 0,
		has_content: false,
		request_user_location: false,
		has_map: false,
		map_center: {
			lat: -33.868820,
			lng: 151.209296
		},
		map_markers: false,
		// most_relevant: {
		// 	category_title: '',
		// 	category_url: '',
		// 	title: '',
		// 	url: '',
		// },
		// also_see: false,
		// suggestion: false,
		// sites_menu: false,
		// sites: false,
		// pages: false,
		// resources: false,
		// resource_categories: false,
		// categories: false,
		// results: false
	},
	placeById: {}
}

export default function searchReducer( state = initialState, action ) {
	switch ( action.type ) {
		case 'OPEN_SEARCH':
			return Object.assign( {}, state, {
				isOpen: true
			})

		case 'CLOSE_SEARCH':
			return Object.assign( {}, state, {
				isOpen: false,
				mapDetailsIsOpen: false,
				searchTerm: ''
			})

		case 'SEARCH':
			return Object.assign( {}, state, {
				isOpen: true,
				searchTerm: action.value
			})

		case 'SUBMIT_SEARCH':
			return state

		// case 'SET_MIXED_RESULTS_STATE':
		// 	return Object.assign( {}, state, {
		// 		mixedResultsState: action.data
		// 	})

		case 'SELECT_MAP_MARKER':
			let markerData = action.data

			if ( state.placeById[ markerData.uuid ] ) {
				markerData = state.placeById[ markerData.uuid ]
			}

			return Object.assign( {}, state, {
				selectedMarker: markerData
			})

		case 'HOVER_MAP_MARKER':
			return Object.assign( {}, state, {
				hoveredMarker: action.data
			})

		case 'SET_MAP_BOUNDS':
			return Object.assign( {}, state, {
				bounds: action.data.bounds,
				mapCenter: action.data.center,
				zoom: action.data.zoom
			})

		case 'SET_ALLOW_MAP_OVERRIDE':
			return Object.assign( {}, state, {
				allowMapOverride: action.data
			})

		case 'SET_CURRENT_POSITION':
			return Object.assign( {}, state, {
				userLatLng: {
					lat: action.latLng.lat,
					lng: action.latLng.lng
				}
			})

		case 'MAPS_API_LOADING':
			return Object.assign( {}, state, {
				isLoading: true
			})

		case 'MAPS_API_LOADED':
			return Object.assign( {}, state, {
				isLoading: false
			})

		case 'TOGGLE_MAP_DETAILS':
			return Object.assign( {}, state, {
				mapDetailsIsOpen: ! state.mapDetailsIsOpen
			})

		case 'CLEAR_MAP_DETAILS':
			return Object.assign( {}, state, {
				selectedMarker: false
			})

		case 'SEARCH_LOADING':
			return Object.assign( {}, state, {
				isLoading: true,
				error: false
			})

		case 'REQUESTING_SEARCH_DATA':
			return Object.assign( {}, state, {
				isRequestingSearchData: true
			})

		case 'REQUESTING_PLACE_DATA':
			return Object.assign( {}, state, {
				isRequestingPlaceData: true
			})

		case 'SET_FILTERS':
			const placeFilters = {
				'church': 'Churches',
				'school': 'Schools',
				'medical': 'Medical Centres',
				'aged_care': 'Aged Care Facilities',
				'opshop': 'Op Shops',
				'recreation': 'Camp Grounds',
				'bookstore': 'Bookstores',
				'ministry': 'Ministries',
				'service': 'Services',
				'pathfinders': 'Pathfinders',
				'adventurers': 'Adventurers',
				'administration': 'Administration'
			}
			let adjustFilters

			if ( action.value in placeFilters ) {
				adjustFilters = {
					'department': false,
					'resource': false
				}
			} else {
				adjustFilters = {
					'department': false,
					'resource': false,
					'church': false,
					'school': false,
					'medical': false,
					'aged_care': false,
					'opshop': false,
					'recreation': false,
					'bookstore': false,
					'ministry': false,
					'service': false,
					'administration': false
				}
			}

			return Object.assign( {}, state, {
				filtersChanged: true,
				filters: {
					...state.filters,
					...adjustFilters,
					[action.value]: ! state.filters[ action.value ]
				}
			})

		case 'RECEIVE_SEARCH_DATA':
			// let mixedResultsState = false

			// if ( action.data.has_map && action.data.has_content ) {
			// 	mixedResultsState = 'all'
			// }

			// set map_center to the existing state value if
			// allowMapOverride is false or if no map_center is returned
			if ( ! state.allowMapOverride || ! action.data.map_center ) {
				action.data.map_center = state.mapCenter
			}

			if ( action.args.blockUI ) {
				return Object.assign( {}, state, {
					isLoading: false,
					isRequestingSearchData: false,
					hasSearched: true,
					// mixedResultsState: mixedResultsState,
					filters: action.data.filters,
					mapCenter: action.data.map_center,
					searchResults: action.data,
					selectedMarker: false,
					error: false
				})
			} else {
				return Object.assign( {}, state, {
					isLoading: false,
					isRequestingSearchData: false,
					hasSearched: true,
					mixedResultsState: mixedResultsState,
					filters: action.data.filters,
					mapCenter: action.data.map_center,
					searchResults: action.data,
					error: false
				})
			}

		case 'RECEIVE_PLACE_DATA':
			let selectedMarker = state.selectedMarker

			if ( state.selectedMarker && state.selectedMarker.uuid == action.uuid ) {
				selectedMarker = {
					...action.data,
					uuid: action.uuid
				}
			}

			return Object.assign( {}, state, {
				isRequestingPlaceData: false,
				placeById: {
					...state.placeById,
					[ action.uuid ]: {
						...action.data,
						uuid: action.uuid
					}
				},
				selectedMarker: selectedMarker,
				error: false
			})

		case 'RECEIVE_ERROR':
			return Object.assign( {}, state, {
				isLoading: false,
				isRequestingPlaceData: false,
				searchResults: action.data,
				error: true
			})
	}

	return state;
}



// WEBPACK FOOTER //
// ./redux/reducers/search.jsx